import React from "react";
import { createRoot } from "react-dom/client";
import { PrivyProvider } from "@privy-io/react-auth";
import { SmartWalletsProvider } from "@privy-io/react-auth/smart-wallets";
import App from "./App";
import { base } from "viem/chains";
import { addRpcUrlOverrideToChain } from "@privy-io/react-auth";
const baseOverride = addRpcUrlOverrideToChain(
  base,
  "https://api.developer.coinbase.com/rpc/v1/base/WMQ4Y6b5ZsqmO9MTCfyjZG2aQXG5T1Ih"
);
import { BlockChainContextProvider } from "contexts/blockchainContext";
import { SharePriceContextProvider } from "contexts/sharePriceContext";
import { PrinxContextProvider } from "contexts/prinxDataContext";
import { REACT_APP_PRIVY_APP_ID } from "env";
import "./i18n";
import "./input.css";
const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    {/* <PrivyProvider
      appId={REACT_APP_PRIVY_APP_ID}
      config={{
        defaultChain: baseOverride,

        appearance: {
          accentColor: "#6A6FF5",
          theme: "#FFFFFF",
          showWalletLoginFirst: false,
          // logo: "https://pub-dc971f65d0aa41d18c1839f8ab426dcb.r2.dev/privy.png",
          // landingHeader: 'Welcome to Prinx! Please create an new account or sign in.',
          loginMessage: "Welcome to Prinx! Please create an new account or sign in"
        },
        loginMethods: ["email", "google"],
        embeddedWallets: {
          createOnLogin: "users-without-wallets",
          requireUserPasswordOnCreate: false
        },
        mfa: {
          noPromptOnMfaRequired: false
        }
      }}
    </PrivyProvider>
    > */}
    <PrinxContextProvider>
      <BlockChainContextProvider>
        <SharePriceContextProvider>
          <SmartWalletsProvider>
            <App />
          </SmartWalletsProvider>
        </SharePriceContextProvider>
      </BlockChainContextProvider>
    </PrinxContextProvider>
  </React.StrictMode>
);
